const colleges = {
    "Bangalore Urban":[
      {value:"Dayananda Sagar College of Engineering",label:"Dayananda Sagar College of Engineering"},
      {value:"RV College of Engineering",label:"RV College of Engineering"},
      {value:"Ramiah Institute of Engineering",label:"Ramiah Institute of Engineering"},
      {value:"BMS College of Engineering",label:"BMS College of Engineering"},
      {value:"Bangalore Institute of Engineering",label:"Bangalore Institute of Engineering"}
    ],
    Mysore:[
      {value:"The National Institute of Engineering",label:"The National Institute of Engineering"},
      {value:"JSS Science & Technology University",label:"JSS Science & Technology University"},
      {value:"Vidyavardhaka College of Engineering",label:"Vidyavardhaka College of Engineering"}
    ],
    Meerut:[
      {value:"Harvard Business School",label:"Harvard Business School"},
      {value:"Massachusets Institute of Technology",label:"Massachusets Institute of Technology"},
      {value:"University of California, Los Angeles",label:"University of California, Los Angeles"}
    ],
    Varanasi:[
      {value:"IIT Banaras Hindu University",label:"IIT Banaras Hindu University"},
      {value:"Ashoka Institute of Technology & Management",label:"Ashoka Institute of Technology & Management"}
    ],
    Delhi : [
      {value : "Indian Institute of Technology Delhi", label : "IIT Delhi"},
      {value : "Delhi Technological University", label : "DTU"}
    ],
    
  }
  
  module.exports.colleges = colleges;